
// reactstrap components
import AddKeyModal from "components/Modals/AddKeyModal";
import AddSocialRecoveryModal from "components/Modals/AddSocialRecoveryModal";
import { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Container, Row, Col, Button } from "reactstrap";
import {  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const ContractsManagerHeader = ({accountData}) => {
  const [contractSize, setContractSize] = useState(0);

  async function getAllContractsSize() {
    const contracts = accountData.contracts ; 
    console.log(contracts)
    let totalContractsSizee = 0;
    for(let i = 0; i < contracts.length; i++){
      console.log(totalContractsSizee)
      totalContractsSizee += (new Blob([contracts[i].code]).size/1024);
    }
    setContractSize(totalContractsSizee);
  }

  useEffect(() => {
    getAllContractsSize();
  },[])
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row className="justify-content-center mb-4">

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"100px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Total Contracts
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{accountData?.contracts?.length}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                          <i className="fas fa-info" />
                        </div>
                      </Col>
                    </Row>
                    
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"100px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Total Contracts Size
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{contractSize} KB</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-red text-white rounded-circle shadow">
                          <i className="fas fa-info" />
                        </div>
                      </Col>
                    </Row>
                   
                  </CardBody>
                </Card>
              </Col>
              
            </Row>

           
          </div>
        </Container>
      </div>


    </>
  );
};

export default ContractsManagerHeader;
